<div *ngIf="isVisible$ | async" class="loading-container">
    <div class="loading-overlay"></div>
    <div class="loading-content">
        <div class="spinner"></div>
        <p class="loading-text">Loading...</p>
    </div>
</div>
